import { Outlet } from 'react-router'
import { Footer } from './footer'
import { Header } from './header'

export function PublicLayout() {
	return (
		<div className="bg-primary flex min-h-screen flex-col justify-between">
			<Header />
			<main className="flex-1">
				<Outlet />
			</main>
			<Footer />
		</div>
	)
}
